import $ from "jquery";

export const isRTL = () => {
    return $("html").attr("dir") === "rtl";
};